<script setup>
import { ref, onMounted, defineEmits  } from "vue";

const emit = defineEmits(['selected']);

const props = defineProps({
    slotData: Object,
    slotIndex: Number,
    selectedSlotIndex: Number,
});
const days = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];

onMounted(() => {
    //console.log(props);
});

function itemClick(slotData, index) {
    //console.log("itemClick", slotData, index);
    emit('selected', {slotData, index});
}

function formatDate(inputDate, timezone = true) {
    //console.log("formatDate", inputDate);
    let date = new Date(inputDate);

    if(timezone) {
        let utc = date.getTime() + (date.getTimezoneOffset() * 60000); // deal with timezone in milliseconds
        date = new Date(utc);
    }

    let weekday = days[date.getDay()],
        day = (date.getDate()).toString().padStart(2, '0'),
        month = (date.getMonth() + 1).toString().padStart(2, '0'),
        year = date.getFullYear();

    return `${weekday}, ${day}.${month}.${year}`;
}

function formatTime(inputDate, timezone = true) {
    let date = new Date(inputDate);

    if(timezone) {
        let utc = date.getTime() + (date.getTimezoneOffset() * 60000); // deal with timezone in milliseconds
        date = new Date(utc);
    }

    let hours = (date.getHours()).toString().padStart(2, '0'),
        minutes = (date.getMinutes()).toString().padStart(2, '0');
    return `${hours}:${minutes}`;
}

</script>

<template>
    <div class="slotlistitem flex flex-col sm:flex-row justify-between sm:h-[5rem] border border-oteoBorder lg:mr-16 px-5 py-4 cursor-pointer hover:"
        :class="{
            'selected': props.slotIndex === props.selectedSlotIndex,
        }"
        @click="itemClick(props.slotData, props.slotIndex)">
        <div class="flex flex-col justify-around">
            <div class="font-semibold">
                <span class="text-lg">{{ formatDate(props.slotData.slot[0]) }}</span>
            </div>
            <div>
                <span class="text-lg">{{ formatTime(props.slotData.slot[0]) }} - {{ formatTime(props.slotData.slot[1]) }} Uhr</span>
            </div>
        </div>

        <div class="flex flex-col justify-end">
            <span class="text-sm">{{ props.slotData.practitioner.fullname }}</span>
        </div>
    </div>
</template>

<style>
.slotlistitem.selected {
    background-color:rgb(234 234 234)
}
</style>
